<template>
  <div class="text-center">
    <v-dialog v-model="dialog" width="600" persistent>
      <v-card height="350">
        <v-card-title class="text-h5 text-center primary lighten-2 mb-4">
          <v-spacer />
          <h1
              class="text-center mb-3 font-weight-light"
              style="font-size: 40px"
          >
            <p>Verify Employee Credentials</p>
          </h1>
          <v-spacer />
        </v-card-title>
        <v-card-text>
          <v-text-field
              v-model="employeeNo"
              outlined
              dense
              placeholder="Enter your Employee Number"
          >
            <template v-slot:label>
              <span>Employee Number</span>
            </template>
          </v-text-field>
        </v-card-text>

        <v-card-text>
          <v-text-field
              v-model="idNo"
              outlined
              dense
              placeholder="Enter your ID Number"
          >
            <template v-slot:label>
              <span>ID Number</span>
            </template>
          </v-text-field>
        </v-card-text>

        <v-divider />

        <v-card-actions class="d-flex justify-end">
          <v-btn
              :loading="$store.getters['loading']"
              @click="dialog = false"
              color="warning"
          >
            Cancel
          </v-btn>

          <v-btn
              :loading="$store.getters['loading']"
              @click="openVerifyEmployee"
              color="primary"
          >
            Request Otp
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {AuthService} from "@/modules/auth";

export default {
  name: "SendEmployeeOtpModal",
  props: {
    userEmail: String,
  },
  data: function () {
    return {
      employeeNo: "",
      idNo: "",
      dialog: false
    };
  },
  mounted() {
    Event.$on("sendEmployeeOtpModal", (value) => {
      this.dialog = value;
    });
  },
  computed: {
    user() {
      return AuthService?.user
    }
  },

  methods: {
    openVerifyEmployee() {
      this.$store.dispatch("Home/openVerifyEmployeeOtp", {
        employeeNo: this.employeeNo,
        idNo: this.idNo,
        profileID: this.user.profileID,
      });
    },
  },
};
</script>

<style scoped></style>
